module.exports = __webpack_public_path__ + "static/img/ic_launcher_round.2d6871e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/ic_launcher_round.png
// module id = AJeV
// module chunks = 17